import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { resourcesOperators,resourcesRoutes } from '../../../helpers/backend_helper';
import DataTableOnlyHelper from '../../../helpers/tables/DataTableOnlyHelper';
import dayjs from 'dayjs';

const ObservationsModal = ({modal,setModal,id,authUser}) => {
	const [ items, setItems ] = useState([]);
	const handleClose = () => {
		setModal({...modal,show:false,id:null});
    }

    const getOperatorsShow = async() =>{
    	const response = await resourcesOperators('show',{},id);
    	setItems(response.observations);
    }
    useEffect(() => {
    	getOperatorsShow()
    }, [])

    let columns = [
		{
			id: 'observation',
			name: 'Observacion',
			selector: row => row.observation,
			sortable: true,
			wrap: true,
		},
		{
			id: 'created_at',
			name: 'Fecha de creación',
			selector: row => dayjs(row.created_at).format('DD/MM/YYYY HH:mm'),
			sortable: true,
			wrap: true,
			width:'35%',
		},
	]
    return (
		<div>
	        <Modal  isOpen={modal.show}>
				<ModalHeader className="bg-primary">Observaciones</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12 mb-2" style={{textAlign:'right'}}>
							<button className="btn btn-sm btn-primary" onClick={() => setModal({show:true,type:2,id:id,function:getOperatorsShow})}>
								<i className="fas fa-solid fa-plus"></i> Agregar
							</button>
						</div>
						<DataTableOnlyHelper tittle={'Observaciones'} columns={columns} items={items} pending={false}/>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={handleClose}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default ObservationsModal;